import $ from 'jquery';
import postalCode from './form-helper/postal-code';
import token from './form-helper/token';
import { Form } from './form';

const FORM_JS_CLASS = 'js-form';

const formHelper = {
  postalCode: postalCode,
  token: token,
  // Init basic forms that have same functionality
  initForms: () => {
    $('.' + FORM_JS_CLASS).each(function () {
      const $form = $(this);
      // If form has no name, use default form instance
      if(!$form.data('form-name')) {
        const form = new Form(this, FORM_JS_CLASS);
        form.init();
      }
    });
  }
}

export default formHelper;
